import { FC, SVGProps } from 'react'

export const Premium: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.74349 10.2819C5.74349 8.50019 7.18787 7.05581 8.96959 7.05581C10.7513 7.05581 12.1957 8.50019 12.1957 10.2819C12.1957 12.0636 10.7513 13.508 8.96959 13.508C7.18787 13.508 5.74349 12.0636 5.74349 10.2819ZM8.96959 5.56684C6.36553 5.56684 4.25452 7.67785 4.25452 10.2819C4.25452 12.886 6.36553 14.997 8.96959 14.997C11.5737 14.997 13.6847 12.886 13.6847 10.2819C13.6847 7.67785 11.5737 5.56684 8.96959 5.56684ZM2.10386 23.6886C2.10386 21.1041 4.199 19.0089 6.78348 19.0089H11.404C13.9885 19.0089 16.0836 21.1041 16.0836 23.6886C16.0836 24.0997 16.417 24.433 16.8281 24.433C17.2393 24.433 17.5726 24.0997 17.5726 23.6886C17.5726 20.2817 14.8108 17.52 11.404 17.52H6.78348C3.37666 17.52 0.614887 20.2817 0.614887 23.6886C0.614887 24.0997 0.948204 24.433 1.35937 24.433C1.77054 24.433 2.10386 24.0997 2.10386 23.6886Z"
      fill="currentColor"
    />
    <path
      d="M22.3539 7.96875C23.0449 11.5268 25.8271 14.3089 29.3851 15C25.8271 15.6911 23.0449 18.4732 22.3539 22.0312C21.6628 18.4732 18.8807 15.6911 15.3226 15C18.8807 14.3089 21.6628 11.5268 22.3539 7.96875Z"
      fill="#DE92F2"
    />
  </svg>
)
